<template>
  <vs-popup class="customer-order-update-popup"
            title="PRODUCT ORDER ITEMS UPDATE"
            @close="onClickClose"
            :active.sync="open"
            :buttons-hidden="true" id="order-update-popup">
    <!-- <vx-card  no-shadow> -->
      <vs-alert title="Warning" color="danger" class="h-auto mb-8 text-center" v-if="is_credit_note_raised">
        Credit note(s) have already been processed for this order.
        <br>
        {{ credit_notes.filter((x) => x.status === 'Active').map((x) => x.credit_note_code).toString() }}
      </vs-alert>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit()" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full md:s-full w-full md:mb-0">
              <vs-table :data="cartItems">
                <template slot="header">
                  <div class="flex items-center justify-between w-full mb-2">
                    <h3>
                      <span class="text-danger text-lg">Available credit ({{ account_currency }}):  <b>{{creditDetails.available_credit}}</b></span>
                    </h3>
                    <div class="flex items-center">
                      <vs-button color="warning" type="border" icon-pack="feather" icon="icon-refresh-cw" size="small" class="mr-2" @click.stop="onClickRecalculateSurcharges">Recalculate Surcharges</vs-button>
                      <vs-button size="small" @click.stop="is_add_item_mode = !is_add_item_mode">{{ is_add_item_mode ? 'Close Product Search' : 'Add more Products to order' }}</vs-button>
                    </div>
                  </div>
                </template>
                <template slot="thead">
                  <vs-th width="10%">PRODUCT CODE</vs-th>
                  <vs-th width="10%">PACK SIZE</vs-th>
                  <vs-th width="12.5%">REQUIRED BY</vs-th>
                  <vs-th width="12.5%">SHIP BY DATE</vs-th>
                  <vs-th width="5%">SENT INVOICED QUANTITY (KG)</vs-th>
                  <vs-th width="5%">ORDER QUANTITY (KG)</vs-th>
                  <vs-th width="10%">INCOTERM</vs-th>
                  <vs-th width="10%">UNIT PRICE (KG)</vs-th>
                  <vs-th width="10%">TOTAL PRICE ({{account_currency}})</vs-th>
                  <vs-th width="15%">ACTIONS</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].formulation_code">
                      {{ data[indextr].formulation_code }}
                    </vs-td>

                    <vs-td>
                      <!-- <v-select v-on:input="onChangePackSize(data[indextr],  indextr)"  :clearable="true" placeholder=""  v-model="data[indextr].pack_size" :appendToBody="false"
                               :options="pack_size_options" label="size" :reduce="option => option.size"
                               :dir="$vs.rtl ? 'rtl' : 'ltr'" class="janaka"></v-select> -->
                      <vs-dropdown>
                        <a class="flex items-center" href="#">
                          {{ data[indextr].pack_size | remove_trailing_zeros }}
                          <i class="material-icons"> expand_more </i>
                        </a>
                        <vs-dropdown-menu style="z-index: 110000;">
                          <vs-dropdown-item v-for="(pack_size, pac_index) in pack_size_options" :key="pac_index" @click.stop="onChangePackSize(data[indextr],  indextr, pack_size.size)">
                            {{ pack_size.size }}
                          </vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>
                    </vs-td>

                    <vs-td>
                      <ValidationProvider :vid="`${indextr}_required_by`" :name="`${indextr}_required_by`" :rules="{required: true, after_date: {
                            target: data[indextr].shipment_date,
                            targetName: 'shipment date'
                          }}" v-slot="{ errors }">
                          
                        <flat-pickr :config="{ dateFormat: 'd/m/Y'}" class="w-full" :name="`${indextr}_required_by`"
                                      v-model="data[indextr].required_by" placeholder="Choose Date" @on-change="onChangeQty(data[indextr], indextr, 'required_by')"/>
                                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </vs-td>

                    <vs-td>
                      <ValidationProvider :vid="`${indextr}_shipment_date`" :name="`${indextr}_shipment_date`" rules="required" v-slot="{ errors }">
                        <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" :name="`${indextr}_shipment_date`"
                                      v-model="data[indextr].shipment_date" placeholder="Choose Date" @on-change="onChangeQty(data[indextr], indextr, 'shipment_date')"/>
                                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </vs-td>

                    

                    

                    <vs-td :data="data[indextr].invoiced_total">
                      <span class="text-danger">{{ data[indextr].invoiced_total }}</span>
                    </vs-td>

                    <vs-td :data="data[indextr].quantity">
                      <ValidationProvider v-if="data[indextr].type === 'List'" :vid="indextr + 'item_quantity' " :name="indextr + 'item_quantity'" :rules="'moq:'+data[indextr].min_order_quantity" v-slot="{ errors }">
                        <vs-input v-on:input="onChangeQty(data[indextr], indextr, 'quantity')"  type="text" v-model="data[indextr].quantity" class="w-full"
                                  :name="indextr + 'item_quantity'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                  :disabled="!tr.is_editable"/>
                      </ValidationProvider>
                      <span class="ml-2" v-if="['Contract', 'Bespoke'].includes(data[indextr].type)"> {{ data[indextr].quantity || '' }} </span>
                    </vs-td>
                    <vs-td :data="data[indextr].incoterm">
                      <select 
                              v-model="data[indextr].incoterm" 
                              class="default-dropdown"
                              @click.stop="onChangeQty(data[indextr], indextr)">
                              <option value="">Select Incoterm</option>
                              <option v-for="option in incoterms" :key="option.id" :value="option.code">
                                {{ option.code }}
                              </option>
                            </select>
                    </vs-td>
                    <vs-td :data="data[indextr].unit_price">
                      {{ data[indextr].unit_price }}
                    </vs-td>

                    <vs-td :data="data[indextr].unit_price">
                      {{data[indextr].quantity ? (Number(data[indextr].unit_price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                    </vs-td>

                    <vs-td :data="data[indextr].formulation_id">
                      <div class="vx-row">
                        <vx-tooltip class="mr-2" text="Remove" position="left" v-if="tr.is_editable">
                          <vs-button @click="onClickRemoveFromCart(data[indextr].id)"
                                     size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-if="['Contract', 'Bespoke'].includes(data[indextr].type) && tr.is_editable" text="Price tiers" position="top">
                          <vs-button :id="'add_button'+''+ indextr" @click.native="onClickCalculatePrice(data[indextr], indextr)"
                                     size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus">Price tiers</vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-if="data[indextr].type === 'List' && tr.is_editable && isPriceChanged(data[indextr])" :text="`Update with new pricing (${account_currency} ${calculateProductListPrice(data[indextr].pe_g, data[indextr].quantity, data[indextr].fx_rate || 1)})`" position="top" class="mr-2">
                          <vs-button :id="'update_price_button'+''+ indextr" @click.native="onClickUpdateListPrice(data[indextr], indextr)"
                                     size="small" color="primary" type="border" icon-pack="feather" icon="icon-refresh-cw">Update Price</vs-button>
                        </vx-tooltip>
                        <vx-tooltip class="flex justify-start mr-2" text="This FG is no longer available in Production" position="top" v-if="data[indextr].formulation_status !== 'Production'">
                          <vs-button class="flex justify-end" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-alert-triangle"></vs-button>
                        </vx-tooltip>
                      </div>
                    </vs-td>

                  </vs-tr>
                </template>

              </vs-table>
            </div>

          </div>
        </form>
      </ValidationObserver>
      <ValidationObserver v-if="is_add_item_mode" ref="add_form" v-slot="{ handleSubmit }">

        <form @submit.prevent="handleSubmit()" autocomplete="off">

          <vs-table v-if="is_add_table_active" :hoverFlat="true" id="sample_list" :data="product_catalog"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container" noDataText="Search and add product to your cart">

            <template slot="header">

              <vs-input icon-pack="feather" icon="icon-search" placeholder="Search here"
                        v-model="filters['search']"
                        class="is-label-placeholder px-3 pb-5 w-full md:w-1/2 xl:w-1/7 rounded-full" />
            </template>

            <template slot="thead">
              <vs-th sort-key="formulation_code">ITS PRODUCT CODE/NAME</vs-th>
              <vs-th sort-key="name">CUSTOMER ITEM CODE/NAME</vs-th>
              <vs-th width="10%">QUANTITY (KG)</vs-th>
              <vs-th width="10%" class="">UNIT PRICE (KG/{{account_currency}})</vs-th>
              <vs-th v-if="!__isCurrencyGbp(account_currency)" width="10%" class="">UNIT PRICE (KG/GBP)</vs-th>
              <vs-th width="10%" class="">INCOTERM</vs-th>
              <vs-th>PACK SIZE</vs-th>
              <vs-th width="10%" class="">TOTAL PRICE ({{account_currency}})</vs-th>
              <vs-th width="15%" class="" v-can="'create-edit-order'">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].formulation_code">
                  <span class="font-bold">{{ data[indextr].formulation_code}}</span> <br>
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td>
                  <div v-if="data[indextr].customer_item_code !== 'N/A'">
                    <span class="font-bold">{{ data[indextr].customer_item_code}}</span> <br>
                    {{ data[indextr].customer_item_name }}
                  </div>
                  <div v-else> N/A </div>
                </vs-td>

                <vs-td :data="data[indextr].quantity">
                  <ValidationProvider v-if="data[indextr].type === 'List'" :vid="indextr + 'quantity' " :name="indextr + 'quantity'" :rules="'moq:'+data[indextr].min_order_quantity" v-slot="{ errors }">
                    <vs-input v-on:input="onAddItemToOrder(data[indextr],  indextr)"  type="text" v-model="data[indextr].quantity" class="w-full"
                              :name="indextr+'quantity'"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                  <span class="ml-2" v-if="['Contract', 'Bespoke'].includes(data[indextr].type)"> {{ data[indextr].quantity || '' }} </span>
                </vs-td>

                <vs-td :data="data[indextr].unit_price">
                  {{data[indextr].unit_price}}
                </vs-td>

                <vs-td  v-if="!__isCurrencyGbp(account_currency)" :data="data[indextr].price">
                  {{ data[indextr].type === 'List' ? calculateProductListPrice(data[indextr].pe_g, data[indextr].quantity) : (data[indextr].unit_price ? (Number(data[indextr].unit_price) / (Number(data[indextr].fx_rate) || 1)).toFixed(2) : '0.00') }}
                </vs-td>

                <vs-td :data="data[indextr].incoterm">
                  <!--                    {{ is_uk_based_customer ? 'DDP' : data[indextr].incoterm }}-->

                            <select 
                              v-model="data[indextr].incoterm" 
                              class="default-dropdown"
                              @click.stop="onAddItemToOrder(data[indextr], indextr)">
                              <option value="">Select Incoterm</option>
                              <option v-for="option in incoterms" :key="option.id" :value="option.code">
                                {{ option.code }}
                              </option>
                            </select>
                            
                </vs-td>

                <vs-td>
                  <!-- <v-select v-on:input="onChangePackSize(data[indextr],  indextr)"  :clearable="true" placeholder=""  v-model="data[indextr].pack_size" :appendToBody="false"
                               :options="pack_size_options" label="size" :reduce="option => option.size"
                               :dir="$vs.rtl ? 'rtl' : 'ltr'" style="z-index: 999 !important;" class="janaka"></v-select> -->
                      <vs-dropdown>
                        <a class="flex items-center" href="#">
                          {{ data[indextr].pack_size }}
                          <i class="material-icons"> expand_more </i>
                        </a>
                        <vs-dropdown-menu style="z-index: 110000;">
                          <vs-dropdown-item v-for="(pack_size, pac_index) in pack_size_options" :key="pac_index" @click.stop="onChangePackSize(data[indextr],  indextr, pack_size.size)">
                            {{ pack_size.size }}
                          </vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>
                </vs-td>

                <vs-td>
                  {{data[indextr].quantity ? (Number(data[indextr].unit_price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                </vs-td>


                <vs-td v-can="'create-edit-order'">
                  <div class="vx-row">
                    <vx-tooltip v-if="['Contract', 'Bespoke'].includes(data[indextr].type)" text="Add/Update price tiers" position="top">
                      <vs-button :id="'add_button'+''+ indextr" @click.native="onClickCalculatePrice(data[indextr], indextr, true)"
                                 size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus">Price tiers</vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>

              </vs-tr>
            </template>


          </vs-table>
        </form>
      </ValidationObserver>
    <!-- </vx-card> -->
    <calculate-product-price-pop-up @changeQtyLayer="changeQtyLayer" ref="calculateProductPricePopUp" v-bind:account_currency="account_currency"/>
    <create-customer-account-limit-request-pop-up v-bind:account_currency="'GBP'" ref="createCustomerAccountLimitRequestPopUp" />
    <customer-credit-check-pop-up v-on:openCreditLimitRequest="openCreditLimitRequest" v-on:refreshData="onlyRefreshData" v-on:onlyRefreshData="onlyRefreshData" ref="customerCreditCheckPopUp"/>

    <vs-popup title="WARNING"
              @close="onClickCloseError"
              :active.sync="errorActive"
              :buttons-hidden="true" id="order-update-popup">
      <div v-text="error_message"></div>
    </vs-popup>
    <vs-prompt
      title="Custom Pack Size"
      acceptText="Save"
      @cancel="active_custom_pack_size_prompt = false"
      @accept="submitCustomPackSize"
      @close="active_custom_pack_size_prompt = false"
      :active.sync="active_custom_pack_size_prompt">
      <div class="con-exemple-prompt">
        <span>Enter the value</span>
        <vs-input v-model="custom_pack_size_val" class="mt-3 w-full" />
      </div>
    </vs-prompt>
    <vs-prompt
      title="ENTER REASON CODE FOR UPDATE"
      acceptText="Save"
      @cancel="active_vam_reason_code_prompt = false"
      @accept="updateOrderItemWithVamReasonCode"
      @close="active_vam_reason_code_prompt = false"
      :active.sync="active_vam_reason_code_prompt">
      <div class="con-exemple-prompt">
        <span>VAM Reason Code</span>
        <v-select :clearable="true" placeholder="" v-model="selected_vam_reason_codes" :appendToBody="false"
              :options="vam_reason_codes" label="name" :reduce="option => option.name"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" class="" multiple></v-select>
      </div>
    </vs-prompt>
    <vs-prompt
      title="Powder Product - Quantity Warning"
      :accept-text="'Close'"
      :cancel-text="''"
      color="warning"
      @close="powder_qty_warning_active = false"
      :active.sync="powder_qty_warning_active">
      <div class="con-exemple-prompt">
        <span>This is a <strong>powder product</strong>. It is recommended to order in multiples of <strong>10 kg</strong> (e.g. 10, 20, 30…). Please review the quantity if needed.</span>
      </div>
    </vs-prompt>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const PackSizeRepository = RepositoryFactory.get('pack_size');
  const AdditionalCostRepository = RepositoryFactory.get('additional_cost');
  const IncotermRepository = RepositoryFactory.get('incoterm')
  const CrmRepository = RepositoryFactory.get('crm');

  import CustomerCreditCheckPopUp from '@/components/popups/customer/product-orders/CustomerCreditCheckPopUp'
  import CreateCustomerAccountLimitRequestPopUp from '@/components/popups/customer/account-limit-request/CreateCustomerAccountLimitRequestPopUp'
  import CalculateProductPricePopUp from "@/components/popups/customer/product-orders/CalculateProductPricePopUp";

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Calculations from '@/mixins/Calculations'
  import Filter from "@/mixins/filter";

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  function initialState() {
    return {
      open: false,
      errorActive: false,
      id: '',
      error_message: '',
      is_add_item_mode: false,
      form: {
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: '',
        delivery_instruction: '',
        formulation_items: []
      },
      incoterms: [],
      default_incoterm: null,
      filters: {},
      countryCodes: [],
      customerUsers: [],
      isCreateFromMainMenu: false,
      customers: [],
      formulations: [],
      addresses: [],
      selectedAddress: '',
      cartItems: [],
      productCatalogues: [],
      onClickAddressChange: true,
      customerId: '',
      creditDetails: {},
      product_catalog: [],
      order_total: 0,
      pack_size_options: [],
      active_custom_pack_size_prompt: false,
      temp_data: {},
      custom_pack_size_val: 0,
      is_add_table_active: true,
      credit_notes: [],
      additional_cost_rules: [],
      exisiting_add_cost: [],
      applicableRules: [],
      active_vam_reason_code_prompt: false,
      selected_vam_reason_codes: [],
      vam_reason_codes: [],
      selected_item_for_update: {},
      updated_field: '',
      powder_qty_warning_active: false
    }
  }

  export default {
    name: 'UpdateProductOrderItemsPopUp',
    data () {
      return initialState()
    },
    props: {
      account_currency  : { type: String,  default: 'GBP'},
      orderInvoices     : { type: Array, default: () => [] },
    },
    methods:{
      async openPopup (id, customerId) {
        try {
          await this.$vs.loading({
            container: '#popup',
            scale: 0.45
          })
          await Object.assign(this.$data, initialState())
          this.id = id
          this.customerId = customerId
          this.open = true;
          await this.fetchAddtionalCostRules()
          await this.getItemsInItemsCart()
          await this.getPackSizeList()
          await this.getCreditDetails()
          await this.getIncoterms()
          await this.fetchVamReasonCodeList()
          this.order_total = this.totalCalculator()
          this.$vs.loading.close('#popup > .con-vs-loading')
        } catch (error) {
          this.$vs.loading.close('#popup > .con-vs-loading')
        }
      },
      async onClickCloseError() {
        await this.getItemsInItemsCart()
        this.errorActive = false
      },
      async refreshData() {
        this.open =false
      },
      async onlyRefreshData() {
        await this.getItemsInItemsCart()
      },
      async getCreditDetails() {
        try {
          const {data} = await CustomerRepository.getCustomerAccountCredit(this.customerId)
          this.creditDetails = data.data
        } catch (e) {

        }
      },
      async openCreditLimitRequest() {
        await this.onlyRefreshData()
        await this.$refs.createCustomerAccountLimitRequestPopUp.openPopup(this.customerId)
      },
      async onClickClose() {
        this.open = false
        this.$emit('refresh')
      },
      filterQueryUpdate (){
        if(this.filters.search) {
          this.loadProductCatalogue()
        }
      },
      async loadProductCatalogue() {
        try {
          const { data } = await CustomerRepository.getListOfProductCatalogue(this.customerId, this.filterQuery)
          const cart_item_ids = this.cartItems.map((x) => x.formulation_id)
          this.product_catalog =  data.data.map((n) => {
            n.quantity = n.contract_quantity
            n.unit_price = n.unit_price !== "" ? n.unit_price : 0
            n.incoterm = n.incoterm !== "" ? n.incoterm : this.default_incoterm
            return n
          }).filter((n) => !cart_item_ids.includes(n.id))
        } catch (e) {

        }
      },
      async getIncoterms() {
        try {
          const {data} = await IncotermRepository.getListOfIncoterms(1, '', 100, '')
          this.incoterms =  data.data
          this.default_incoterm = this.incoterms.find((x) => x.is_default).code
        } catch(e) {
          this.convertAndNotifyError(e)
        }
      },
      async onAddItemToOrder(row_data, index) {
        let data = {}
        Object.assign(data, row_data)
        if (Number(data.quantity) < Number(data.min_order_quantity && data.type === 'List') || !data.quantity) {
          return null
        }
        data.type = data.type === 'List' ? 'price' : 'contract'
        if(data.type === 'price') {
          let unit_price = this.calculateProductListPrice(data.pe_g, data.quantity, data.fx_rate)
          this.product_catalog[index].unit_price =  unit_price
          data.unit_price =  unit_price
        }
        this.addCart(data, this);
      },
      async getItemsInItemsCart() {
        try {
          const {data} = (await CustomerRepository.getCustomerProductOrder(this.id)).data
          this.form = data
          this.exisiting_add_cost =  data.add_costs
          this.credit_notes = data.created_credit_note
          this.cartItems = data.formulation_items.map((x) => { 
              x.is_editable = this.checkIfAnyWoWithOutCancelled(x.item_status)
              return x;
           })
            // .filter((x) => this.checkIfAnyWoWithOutCancelled(x.work_orders, x.item_status, x.quantity ))

          this.productCatalogues = (await CustomerRepository.getListOfCartProductCatalogue(
            { customer_id: this.customerId, formulation_ids: this.cartItems.map((x) => x.formulation_id) }
          )).data.data

          this.cartItems = this.cartItems.map((n) => {
            const find =  this.productCatalogues.find((m) => m.id === n.formulation_id)
            n.incoterm = n.incoterm
            n.unit_price = n.price
            n.price = find ? find.price : n.price
            n.contract_price = find ? find.contract_price : 0
            n.original_pe_g = n.pe_g
            n.pe_g = find ? find.pe_g : n.pe_g
            n.type = find ? find.type : 'List'
            n.formulation_type = find ? find.formulation_type : n.formulation_type
            n.work_orders = n.work_orders
            n.invoiced_total  = this.getAlreadyInvoicedQty(n.formulation_code)
            n.total_active_wo_qty = this.totalActiveWoQuantity(n.work_orders)
            n.min_order_quantity = find ? (Number(find.min_order_quantity) > n.total_active_wo_qty ? find.min_order_quantity : n.total_active_wo_qty) : 0
            n.is_editable = find ? n.is_editable : false
            n.current_shipping_cost = find ? find.current_shipping_cost : 0
            n.shipping_cost = find ? find.shipping_cost : 0
            n.fx_rate = find ? find.fx_rate : 1
            return n
          })

        }catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      getAlreadyInvoicedQty(formulation_code) {
        let related_inv = this.order_invoices.filter((m) => formulation_code === m.formulation_code)
        return related_inv.reduce((a, b) => a + Number(b.quantity), 0)
      },
      async onClickRemoveFromCart(id) {
        try {
          await CustomerRepository.removeItemFromCustomerProductOrder(id)
          await this.getItemsInItemsCart()
          this.checkRules(this.cartItems, this.additional_cost_rules)
          await this.saveOrderDetails()
          this.exisiting_add_cost = JSON.parse(JSON.stringify(this.applicableRules))
          await this.getItemsInItemsCart()
          await this.getCreditDetails()
          this.order_total = this.totalCalculator()
          this.showSuccessMessage('Product item removed from order')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      async onClickAddToCart(data) {
        await this.$vs.loading({
          container: '#popup',
          scale: 0.45
        })
        try {
          await CustomerRepository.AddItemToCustomerProductOrder(this.id, {
            formulation_items: [{ id: data.id, price: data.unit_price, quantity: data.quantity, type: data.type, incoterm: data.incoterm, pack_size: data.pack_size ? Number(data.pack_size).toFixed(3) : "0.000", required_by: null }]
          })
          this.product_catalog = []
          this.filters.search = ''
          this.is_add_item_mode = false
          await this.getItemsInItemsCart()
          this.checkRules(this.cartItems, this.additional_cost_rules)
          await this.saveOrderDetails()
          this.exisiting_add_cost = JSON.parse(JSON.stringify(this.applicableRules))
          await this.getItemsInItemsCart()
          await this.getCreditDetails()
          this.order_total = this.totalCalculator()
          this.showSuccessMessage('Product item added to order')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#popup > .con-vs-loading')
      },
      async onClickUpdateFromCart(data, index, field = '') {
        this.selected_item_for_update = data
        this.updated_field = field
        if(field === 'quantity' || field === 'shipment_date' || field === 'required_by') {
          this.active_vam_reason_code_prompt = true
        }else {
          await this.updateOrderItemWithVamReasonCode()
        }
      },
      async updateOrderItemWithVamReasonCode() {
        await this.$vs.loading({
          container: '#order-update-popup',
          scale: 0.45
        })
        try {
          await CustomerRepository.updateItemFromCustomerProductOrder(this.selected_item_for_update.id, {
            quantity: this.selected_item_for_update.quantity, price: this.selected_item_for_update.unit_price, required_by: this.selected_item_for_update.required_by, incoterm: this.selected_item_for_update.incoterm, pack_size: Number(this.selected_item_for_update.pack_size).toFixed(3), shipment_date: this.selected_item_for_update.shipment_date, vam_type: this.selected_vam_reason_codes || ''
          })
          // await this.getItemsInItemsCart()
          if (['required_by', 'shipment_date'].includes(this.updated_field)) {
            this.applicableRules = this.exisiting_add_cost.map((x) => {
              return {
                name: x.name,
                amount: Number(x.amount).toFixed(2),
                vat_percent: Number(x.vat_percent).toFixed(2),
                sage_nominal_code_id: x.sage_nominal_code_id,
                is_removed: x.is_removed || false
              }
            })
          } else {
            this.checkRules(this.cartItems, this.additional_cost_rules)
          }
          await this.saveOrderDetails()
          this.exisiting_add_cost = JSON.parse(JSON.stringify(this.applicableRules))
          await this.getItemsInItemsCart()
          await this.getCreditDetails()
          this.order_total = this.totalCalculator()
          this.showSuccessMessage('Product item updated')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#order-update-popup > .con-vs-loading')
      },
      totalCalculator() {
        let total = 0;
        this.cartItems.forEach((m) => {
          if (!!m.unit_price) {
            total = total + Number(m.unit_price) * Number(m.quantity)
          }

        })
        return total.toFixed(2)
      },
      async onChangeQty(row_data, index, field = '') {
        let data = {}
        Object.assign(data, row_data)
        if (Number(data.quantity) < Number(data.min_order_quantity) && data.type === 'List' || Number(data.quantity) === 0) {
          return null
        }
        if(data.type === 'price') {
          let unit_price = this.calculateProductListPrice(data.pe_g, data.quantity, 1)
          this.cartItems[index].unit_price =  unit_price
          data.unit_price =  unit_price
        } else {
          this.cartItems[index].unit_price = row_data.unit_price
          this.cartItems[index].quantity = row_data.quantity
        }

        await this.$nextTick()
        const requiredValid = await this.$refs.form.refs[
          `${index}_required_by`
        ].validate()

        const shipmentValid = await this.$refs.form.refs[
          `${index}_shipment_date`
        ].validate()

        if (requiredValid.valid && shipmentValid.valid) {
            this.updateCart(data, index, this, field)
        }
      },
      async changeQtyLayer(e) {
        if(e.is_only_add) {
          await this.onAddItemToOrder(e.data, e.index)
        } else {
          await this.onChangeQty(e.data, e.index)
        }
      },
      isPowderQtyValid(data) {
        if (!data.formulation_type) return true
        const type = String(data.formulation_type).toLowerCase()
        if (type !== 'powder') return true
        const qty = Number(data.quantity)
        return qty > 0 && qty % 10 === 0
      },
      addCart: _.debounce( async (data, vm) => {

        // Powder product: quantity must be a multiple of 10 (warning only, still proceeds)
        if (!vm.isPowderQtyValid(data)) {
          vm.powder_qty_warning_active = true
        }
        if (!vm.isCanAddOrderWithCredit()) {
          await vm.openCreditCheckPopUp()
          return null
        }
        await vm.onClickAddToCart(data)
      }, 1500),
      updateCart: _.debounce( async (data, index, vm, field = '') => {
        // Powder product: quantity must be a multiple of 10 (warning only, still proceeds)
        if (!vm.isPowderQtyValid(data)) {
          vm.powder_qty_warning_active = true
        }
        if (!vm.isCanAddOrderWithCredit()) {
          await vm.openCreditCheckPopUp()
          return null
        }
        if(field == 'quantity'){
          if(!vm.isCanUpdateItemWithInvoicedQty(data.invoiced_total, data.quantity)) {
            vm.error_message = `You cannot reduce the SO item ( ${data.formulation_code} ) quantity that has been invoiced ( ${data.invoiced_total} KG ). Cancel invoice if needed.`
            vm.errorActive = true
            return null
          }
        }
        if (Number(data.quantity) > 0 ) {
          await vm.onClickUpdateFromCart(data, index, field)
        }
      }, 500),
      isCanAddOrderWithCredit() {
        if(this.creditDetails.account_type === 'proforma') {
          return true
        }
        const cart_total = this.totalCalculator()
        const available_credit = Number(this.creditDetails.available_credit) + Number(this.order_total)
        return Number(cart_total) <= Number(available_credit)
      },
      isCanUpdateItemWithInvoicedQty(invoiced_qty, selected_qty) {
        return invoiced_qty <= Number(selected_qty)
      },
      async openCreditCheckPopUp() {
        await this.$refs.customerCreditCheckPopUp.openPopup(this.customerId)
      },
      async onClickCalculatePrice(data, index, is_only_add = false) {
        try {
          if(data.price.length === 0) {
            alert('error in price tiers')
            return
          }
          await this.$refs.calculateProductPricePopUp.openPopup(data, index, is_only_add)
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      async onClickUpdateListPrice(row_data, index) {
        try {
          if (!row_data.pe_g || !row_data.quantity || Number(row_data.quantity) <= 0) {
            return
          }
          let data = {}
          Object.assign(data, row_data)
          const unit_price = this.calculateProductListPrice(data.pe_g, data.quantity, data.fx_rate || 1)
          this.cartItems[index].unit_price = unit_price
          data.unit_price = unit_price
          await this.updateCart(data, index, this, 'price')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      isPriceChanged(item) {
        if (!item || item.type !== 'List' || !item.pe_g || !item.quantity || Number(item.quantity) <= 0) {
          return false
        }
        const new_unit_price = this.calculateProductListPrice(item.pe_g, item.quantity, item.fx_rate || 1)
        return Number(new_unit_price).toFixed(2) !== Number(item.unit_price || 0).toFixed(2)
      },
      checkIfAnyWoWithOutCancelled(status) {
        const editableStatuses = ['Pending', 'In-Manufacturing', 'In-QC', 'In-Dispatch', 'Submitted']
        return editableStatuses.includes(status)
      },
      totalActiveWoQuantity(work_orders) {
        return work_orders.filter(x => x.status !== 'Cancelled').reduce((a, c) => a + parseFloat(c.completed_quantity), 0)
      },
      async getPackSizeList() {
        try {
          const {data} = await PackSizeRepository.getListOfPackSize(1, '', 100, '')
          this.pack_size_options =  data.data.map((x) => {
            x.size = this.__removeTrailingZeros(x.size)
            return x
          })
          this.pack_size_options.push({ size: 'custom size' })
        } catch(e) {
          this.convertAndNotifyError(e)
        }
      },
      onChangePackSize(data, index, pack_size) {
        this.is_add_table_active = !this.is_add_table_active
        this.is_add_table_active = !this.is_add_table_active
        data.pack_size = pack_size
        if(data.pack_size !== 'custom size') {
          this.is_table_display = !this.is_table_display
          this.is_table_display = !this.is_table_display
          this.onChangeQty(data, index)
        } else {
          this.open = !this.open
          this.temp_data = { data, index }
          this.custom_pack_size_val = 0
          this.active_custom_pack_size_prompt = !this.active_custom_pack_size_prompt
        }
      },
      submitCustomPackSize() {
        this.is_add_table_active = !this.is_add_table_active
        this.is_add_table_active = !this.is_add_table_active
        this.active_custom_pack_size_prompt = !this.active_custom_pack_size_prompt
        this.open = !this.open
        this.temp_data.data.pack_size = this.custom_pack_size_val
        this.onChangeQty(this.temp_data.data, this.temp_data.index)
      },
      async fetchAddtionalCostRules() {
        const { data } = await AdditionalCostRepository.getAdditionalCostList(1, '', 50, '')
        this.additional_cost_rules = data.data
      },
      async saveOrderDetails() {
        try {
          let create_form = {}
          create_form.name =  this.form.name
          create_form.line1 =  this.form.line1
          create_form.line2 =  this.form.line2
          create_form.line3 =  this.form.line3
          create_form.town_state =  this.form.town_state
          create_form.post_code =  this.form.post_code
          create_form.country =  this.form.country
          create_form.delivery_instruction =  this.form.delivery_instruction
          create_form.note = this.form.note
          create_form.customers_order_number =  this.form.customers_order_number
          create_form.sage_department_id = this.form.sage_department && this.form.sage_department.id ? this.form.sage_department.id : null
          create_form.region_id = this.form.region && this.form.region.id ? this.form.region.id : null
          create_form.add_costs = this.applicableRules
          await CustomerRepository.updateCustomerProductOrder(this.form.id, create_form)
        } catch (error) {
          
        }
      },
      checkRules(cartItems, rules) {
        const applicableRules = [];

        if (!Array.isArray(cartItems) || !Array.isArray(rules)) {
          this.applicableRules = applicableRules
          return
        }

        cartItems.forEach(item => {
            rules.forEach(rule => {
                if (rule.product_types && Array.isArray(rule.product_types) && rule.product_types.includes(item.formulation_type)) {
                    const itemQuantity = parseFloat(item.quantity);
                    const ruleQuantity = parseFloat(rule.quantity);
                    
                    let conditionMet = false;
                    switch (rule.condition) {
                        case "gte":
                            conditionMet = itemQuantity >= ruleQuantity;
                            break;
                        case "gt":
                            conditionMet = itemQuantity > ruleQuantity;
                            break;
                        case "lte":
                            conditionMet = itemQuantity <= ruleQuantity;
                            break;
                        case "lt":
                            conditionMet = itemQuantity < ruleQuantity;
                            break;
                        case "eq":
                            conditionMet = itemQuantity === ruleQuantity;
                            break;
                    }
                    if (conditionMet) {
                      const find_currency_price = Array.isArray(rule.currencies) ? rule.currencies.find((x) => x.currency === this.account_currency) : null
                        applicableRules.push({
                            name: rule.name,
                            amount: parseFloat(find_currency_price ? find_currency_price.amount : 0).toFixed(2),
                            vat_percent: "0.00",
                            sage_nominal_code_id: rule.sage_nominal_code_id,
                            is_removed:false,
                        });
                    }
                }
            });
        });
        this.applicableRules = applicableRules
        // return applicableRules;
      },
      async fetchVamReasonCodeList() {
        try {
          const { data } = (await CrmRepository.getListVamType()).data
          this.vam_reason_codes = data
        } catch (error) {
          
        }
      },
      async onClickRecalculateSurcharges() {
        await this.$vs.loading({
          container: '#order-update-popup',
          scale: 0.45
        })
        try {
          await this.fetchAddtionalCostRules()
          await this.getItemsInItemsCart()
          this.checkRules(this.cartItems, this.additional_cost_rules)
          await this.saveOrderDetails()
          this.showSuccessMessage(`Order surcharges updated (${this.applicableRules.length} applicable surcharge(s))`)
          await this.onClickClose()
        } catch (e) {
          this.convertAndNotifyError(e)
        } finally {
          this.$vs.loading.close('#order-update-popup > .con-vs-loading')
        }
      }
    },
    components: {
      'v-select': vSelect,
      CustomerCreditCheckPopUp,
      CreateCustomerAccountLimitRequestPopUp,
      CalculateProductPricePopUp,
      flatPickr
    },
    computed: {
      order_invoices: function () {
        let inv_items = []
        this.orderInvoices
          .filter((x) => ['Sent', 'Paid'].includes(x.status.name))
          .forEach((n) => { inv_items = inv_items.concat(n.items)})
        return inv_items
      },
      is_credit_note_raised: function() {
        return this.credit_notes.some((x) => x.status === 'Active')
      }
    },
    mixins: [SuccessMessage, ErrorMessages, Calculations, Filter],
  }
</script>

<style scoped>
  .customer-order-update-popup >>> .vs-popup {
    /*min-height: 80% !important;*/
    min-width: 80% !important;
  }
  .loader {
    text-align: center;
    color: #bbbbbb;
  }


</style>
